import Vue from 'vue';

const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  
  ticketSummaryReport ({commit}, params) {
    var filters = params.filters || {};

    if (!params.property) {
      return Promise.reject('state.property - ticketSummaryReport - Missing required param "property"');
    }

    var queryParams = {
      ...filters
    };

    if (params.from) queryParams.start = params.from;
    if (params.to) queryParams.end = params.to;

    return window.server.getReq('property/' + params.property + '/report/summary', {
      params: queryParams
    })
    .then(data => {

      return Promise.resolve(data);
    })  
    .catch(e => {
      return Promise.reject(e);
    });
  }
};

export default {
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/report.js